'use client';
import usePlatform from '@haaretz/s-atoms/platform';
import browserStorageGetItem from '@haaretz/s-browser-storage-utils/getItem';
import browserStorageSetItem from '@haaretz/s-browser-storage-utils/setItem';
import { appScopeName } from '@haaretz/s-consts';
import useDocumentEventListener from '@haaretz/s-use-native-application/useDocumentEventListener';
import useOnce from '@haaretz/s-use-once';
import React from 'react';
const AUDIO_READER_TOGGLE_KEY = 'htzToggleAudioReader';
/**
 * This hook is used to check if the native application has showing the webview.
 * If used in the web browser, it will return true immediately.
 *
 * @param onLoad - A callback to be called when the native application has showing the webview.
 */ export default function useShowAudioReader(onLoad) {
    const platform = usePlatform();
    const toggleAudioReaderCallHistory = typeof window === 'undefined' ? /* istanbul ignore next */ undefined : window[appScopeName]?.Iphone.callHistory.toggleAudioReader ?? undefined;
    const [isShowing, setIsShowing] = React.useState(false);
    const shouldLoad = isShowing || toggleAudioReaderCallHistory?.at(-1)?.[0] === 'show';
    const onShowingAudioReader = React.useCallback((event)=>{
        const args = event.detail || [];
        const [action] = args;
        const isShow = action === 'show';
        setIsShowing(isShow);
        updateAudioReaderStatus(isShow ? 'show' : 'hide');
    }, []);
    useOnce(()=>{
        const toggleAudioReader = browserStorageGetItem({
            key: AUDIO_READER_TOGGLE_KEY,
            storage: 'local'
        });
        if (!toggleAudioReader) {
            updateAudioReaderStatus('show');
        }
    }, false);
    useOnce(()=>{
        onLoad?.();
    }, shouldLoad && typeof onLoad === 'function');
    useDocumentEventListener('toggleAudioReader', onShowingAudioReader, false);
    return shouldLoad;
}
function updateAudioReaderStatus(status) {
    return browserStorageSetItem({
        key: AUDIO_READER_TOGGLE_KEY,
        value: status,
        storage: 'local'
    });
}

//# sourceMappingURL=useShowAudioReader.js.map